import React, { Component } from "react";
import image1 from "../../header/assets/cheerful-close-up-coffee.jpg";
import image2 from "../../header/assets/black-and-white-close-up-dark-167964.jpg";
import image3 from "../../header/assets/food-health-plate.jpg";
import "./assets/feature.scss";

export default class Stories extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div>
                <div className="row">
                    <div className="col-md-4 col-lg-4 col-sm-6 col-xs-12">
                        <div className="single-blog">
                            <div className="blog-image">
                                <img src={image1} alt="" />
                            </div>
                            <div className="blog-details text-center">
                                <h3><a href="single-blog.html">Story One</a></h3>
                                <p>this is an example snippet of content that will be shown to the reader as part of a users story...</p>
                                <a href="#" className="read-more">Read More</a>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4 col-lg-4 col-sm-6 col-xs-12">
                        <div className="single-blog">
                            <div className="blog-image">
                                <img src={image2} alt="" />
                            </div>
                            <div className="blog-details text-center">
                                <h3><a href="single-blog.html">Story Two</a></h3>
                                <p>this is an example snippet of content that will be shown to the reader as part of a users story...</p>
                                <a href="single-blog.html" className="read-more">Read More</a>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4 col-lg-4 col-sm-12 col-xs-12">
                        <div className="single-blog">
                            <div className="blog-image">
                                <img src={image3} alt="" />
                            </div>
                            <div className="blog-details text-center">
                                <h3><a href="single-blog.html">Story Three</a></h3>
                                <p>this is an example snippet of content that will be shown to the reader as part of a users story...</p>
                                <a href="single-blog.html" className="read-more">Read More</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="secondary-cta">
                    <a href="#">view stories</a>
                </div>

            </div>
        );

    }

}



// WEBPACK FOOTER //
// ./src/containers/main/features/Stories.js